var map = {
	"./Ikonka_dlya_prilozhenia_monetizatsia.png": 328,
	"./ava.png": 866,
	"./bg_blue.png": 389,
	"./bg_red.png": 390,
	"./car.png": 867,
	"./chat_boot.png": 329,
	"./come.png": 868,
	"./communication.png": 869,
	"./down.png": 392,
	"./film.png": 870,
	"./logo.png": 391,
	"./persik.png": 871,
	"./phone.png": 330,
	"./relation.png": 872,
	"./restaurant.png": 873,
	"./welcome-logo.png": 331
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 865;